// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".internal-action-checklist-header-input {\n  float: right !important;\n  margin-top: -5px;\n  padding-right: 5px;\n}\n.internal-action-checklist-header-input .customSelect {\n  padding-bottom: 0 !important;\n}\n.internal-action-checklist-header-input .customSelect .q-field__inner {\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
